<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div style="margin: 15px 0 0 25px;">
    <div *ngIf="integrationsLoaded">
        <span class="integrations-data-loaded"></span>
    </div>

    <h2>{{fD3EThird}}</h2>
    <p>{{fD3EThirdDesc}}</p>

    <div id="integrations" class="card-container">

        @if (active_directory_enabled && showAzureDirectory) {
            <app-integration-card [config]="activeDirectory" integrationType="Active Directory" (delete)="deleteIntegration($event)" setUpUrl="active-directory" [deleteEnabled]="deleteEnabled">
                <div class="logo-container">
                    <img class="azure-logo" src="../../../assets/microsoft-entra-ID-color-icon.svg" alt="Entra ID Logo">
                    <div class="azure-logo-text-container">
                        <span class="azure-logo-text">Microsoft</span>
                        <span class="azure-logo-text">Entra ID</span>
                    </div>
                </div>
                <div class="toggle-container" >
                    <div [ngClass]="activeDirectory ? '' : 'disabled'">{{'INT_AD' | translate}}</div>
                    <div>
                        <mat-slide-toggle color="primary" [disabled]="!activeDirectory" [ngModel]="activeDirectory && activeDirectory.enabled" (change)="onEnabledChanged(activeDirectory.id, $event)" aria-label="Enable Active Directory integration"></mat-slide-toggle>
                    </div>
                </div>
            </app-integration-card>
        }

        @if (showOkta) {
            <app-integration-card [config]="okta" integrationType="Okta" setUpUrl="okta" (delete)="deleteIntegration($event)">
                <div class="logo-container">
                    <div [ngClass]="{'okta-logo-light': (theme$ | async) === 'light', 'okta-logo-dark': (theme$ | async) === 'dark'}">
                        <span class="logo"></span>
                    </div>
                </div>
                <div class="toggle-container">
                    <div>{{'okta-enable-integration' | translate}}</div>
                    <div>
                        <mat-slide-toggle color="primary" [disabled]="!okta" [ngModel]="okta?.enabled" (change)="onEnabledChanged(okta.id, $event)" aria-label="Enable Okta Access"></mat-slide-toggle>
                    </div>
                </div>
            </app-integration-card>
        }

        <app-integration-card [config]="ciscoDuo" integrationType="Cisco Duo" (delete)="deleteIntegration($event)" setUpUrl="cisco-duo">
            <div class="logo-container">
                <img height="60" src="../../../assets/duo-logo-green.png" alt="Cisco DUO Logo">
            </div>
        </app-integration-card>


    </div>

    <h2>{{fCloud}}</h2>
    <p>{{fConfig}}</p>

    <div class="card-container" appLifecycleTracker trackerName="manage-integrations">
<!--        <app-integration-card [config]="sophos" integrationType="Sophos" (delete)="deleteIntegration($event)" setUpUrl="sophos">
            <div class="logo-container">
                <img height="48" src="../../../assets/sophos_central.png" alt="Sophos Logo">
            </div>
            <div class="toggle-container" >
                <div [ngClass]="sophos ? '' : 'disabled'">{{fSophos}}</div>
                <div>
                    <mat-slide-toggle color="primary" [disabled]="!sophos" [ngModel]="sophos && sophos.enabled" (change)="onEnabledChanged(sophos.id, $event)" aria-label="Enabled Sophos integration"></mat-slide-toggle>
                </div>
            </div>
            <div class="toggle-container" >
                <div>{{fSophosLocal}}</div>
                <div>
                    <mat-slide-toggle color="primary" [ngModel]="sophosLocal" (change)="onLocalEnabledChanged('sophos', $event)" aria-label="Intercept X Endpoint (local)"></mat-slide-toggle>
                </div>
            </div>
        </app-integration-card>-->

        <app-integration-card [config]="sentinelOne" [showHealth]="true" integrationType="Sentinel One" (delete)="deleteIntegration($event)" setUpUrl="sentinel-one">
            <div class="logo-container">
                <span [ngClass]="{'light-sentinel-one-logo': (theme$ | async) === 'light', 'dark-sentinel-one-logo': (theme$ | async) === 'dark'}"></span>
            </div>
            <div class="logo-container">
                {{'integrations.sentinel-one.title' | translate}}
            </div>
            <div class="toggle-container" >
                <div [ngClass]="sentinelOne ? '' : 'disabled'">{{'integrations.sentinel-one.title-console' | translate}}</div>
                <div>
                    <mat-slide-toggle color="primary" [disabled]="!sentinelOne" [ngModel]="sentinelOne && sentinelOne.enabled" (change)="onEnabledChanged(sentinelOne.id, $event)" aria-label="Enable Sentinel One integration"></mat-slide-toggle>
                </div>
            </div>
        </app-integration-card>
    </div>
<!--
    <div class="card-container">
        <app-integration-card [config]="ciscoAmp" integrationType="Cisco Secure Endpoint" (delete)="deleteIntegration($event)" setUpUrl="cisco-amp">
            <div class="amp-logo-container">
                <img height="64" src="../../../assets/cisco.png" alt="Cisco Logo">
            </div>
            <div class="amp-logo-container">
                {{fCisco}}
            </div>
            <div class="amp-toggle-container" >
                <div [ngClass]="ciscoAmp ? '' : 'disabled'">{{fCiscoCloud}}</div>
                <div>
                    <mat-slide-toggle color="primary" [disabled]="!ciscoAmp" [ngModel]="ciscoAmp && ciscoAmp.enabled" (change)="onEnabledChanged(ciscoAmp.id, $event)" aria-label="Enable Cisco Secure Endpoint Cloud integration"></mat-slide-toggle>
                </div>
            </div>
            <ul>
            <li *ngIf="ciscoAmp && ciscoAmp.config &&  ciscoAmp.config.unique_id" style="margin-top: 5px">
                <span>{{fStream}}</span>{{fStreamUID}}{{ciscoAmp.config.unique_id}}
            </li>
            <li *ngIf="ciscoAmp && ciscoAmp.config &&
                        ciscoAmp.config.runtime_config && ciscoAmp.config.runtime_config.amp_queue_name" style="margin-top: 5px">
                <span>{{fStreamID}}</span>{{fColon}}{{ciscoAmp.config.runtime_config.amp_queue_name}}
            </li>
            </ul>

        </app-integration-card>

        <app-integration-card [config]="cyberark" integrationType="CyberArk Endpoint Privilege Manager" (delete)="deleteIntegration($event)" setUpUrl="cyberark-epm">
            <div class="logo-container">
                <span [ngClass]="{'light-cyberark-logo': (theme$ | async) === 'light', 'dark-cyberark-logo': (theme$ | async) === 'dark'}" alt="CyberArk Logo"></span>
            </div>
            <div class="logo-container">
                {{fEPM}}
            </div>
            <div class="toggle-container" >
                <div [ngClass]="cyberark ? '' : 'disabled'">{{fEPMC}}</div>
                <div>
                    <mat-slide-toggle color="primary" [disabled]="!cyberark" [ngModel]="cyberark && cyberark.enabled" (change)="onEnabledChanged(cyberark.id, $event)" aria-label="Enable CyberArk Endpoint Privilege Manager integration"></mat-slide-toggle>
                </div>
            </div>
        </app-integration-card>
    </div>

    <div class="card-container">
        <app-integration-card [config]="carbonBlack" integrationType="Carbon Black" (delete)="deleteIntegration($event)" setUpUrl="carbon-black" disabled="true">
            <div class="logo-container">
                <img height="48" src="../../../assets/vmware-carbon-black.png" alt="VMware Carbon Black Logo">
            </div>
            <div class="toggle-container" >
                <div [ngClass]="carbonBlack ? '' : 'disabled'">{{fCBC}}</div>
                <div>
                    <mat-slide-toggle color="primary" [disabled]="!carbonBlack" [ngModel]="carbonBlack && carbonBlack.enabled" (change)="onEnabledChanged(carbonBlack.id, $event)" aria-label="Enabled Carbon Black integration"></mat-slide-toggle>
                </div>
            </div>
            <div class="toggle-container" >
                <div>{{fCBCLocal}}</div>
                <div>
                    <mat-slide-toggle color="primary" [ngModel]="carbonBlackLocal" (change)="onLocalEnabledChanged('carbon-black', $event)" aria-label="Enable Carbon Black Endpoint (local)"></mat-slide-toggle>
                </div>
            </div>
        </app-integration-card>
    </div>-->

    <div *ngIf="showTestIntegration">
        <h2>{{'integrations.testing-section' | translate}}</h2>
        <p>{{'integrations.testing-section-descr' | translate}}</p>

        <div class="card-container" appLifecycleTracker trackerName="manage-integrations">
                <div class="card-container">
            <app-integration-card [config]="cigentTesting" integrationType="Cigent Testing" (delete)="deleteIntegration($event)" setUpUrl="cigent-testing">
                <div class="logo-container">
                    <img height="48" src="../../../assets/cigent-logo-mini.png" alt="Cigent Testing Logo">
                </div>
                <div class="toggle-container" >
                    <div [ngClass]="cigentTesting ? '' : 'disabled'">{{'integrations.testing.title' | translate}}</div>
                    <div>
                        <mat-slide-toggle color="primary" [disabled]="!cigentTesting" [ngModel]="cigentTesting && cigentTesting.enabled" (change)="onEnabledChanged(cigentTesting.id, $event)" aria-label="Enabled Carbon Black integration"></mat-slide-toggle>
                    </div>
                </div>
                <ul>
                    <li *ngIf="cigentTesting && cigentTesting.config  && cigentTesting.config.device_name" style="margin-top: 5px">
                        <span>{{'integrations.testing.device_name' | translate }}</span>{{cigentTesting.config.device_name}}
                    </li>
                </ul>
            </app-integration-card>
            </div>
        </div>
    </div>
<!--
    <h2>
        <button id="add-app-button" color="primary" mat-icon-button (click)="createThirdPartyIntegration()"
                [disableRipple]="true" aria-label="Add API Token" title="Add API Token Button">
            <span class="mdi mdi-plus-box-outline"></span>
        </button>
        {{fAPIToken}}
    </h2>
    <p>{{fGenToken}}</p>

    <mat-table *ngIf="apiTokens.length" [dataSource]="apiTokens">

        <ng-container matColumnDef="display_name">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{fName}}</th>
            <td mat-cell *matCellDef="let integration">
                <a [routerLink]="['/third-party', integration.id]">{{ integration.display_name }}</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="sensor_type">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{fThreatNumber}}</th>
            <td mat-cell *matCellDef="let integration">{{ integration.config.sensorType }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{fThreatDesc}}</th>
            <td mat-cell *matCellDef="let integration">{{ integration.config.description }}</td>
        </ng-container>

        <ng-container matColumnDef="buttons">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{fAction}}</th>
            <td mat-cell *matCellDef="let integration">
                <button mat-raised-button (click)="copy(integration.token)">{{fCopy}}</button>
                <button mat-raised-button (click)="deleteIntegration(integration.id)">{{fDelete}}</button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columns"></tr>

    </mat-table>

    <div *ngIf="!apiTokens.length" class="no-integrations">
        <h2>{{fNoTokens}}</h2>
    </div>-->
</div>
